import { Fragment, ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { FieldErrorMessage, Label, Paragraph, tokens } from '@treams/treams-ui';

import DetailsTableFormValue, {
	DetailsTableFormValueTypes,
	IOptions,
} from './DetailsTableFormValue';

interface IProps {
	formValues: {
		label: string;
		name: string;
		initialValue?: string | number | boolean | Date | null;
		options?: IOptions[];
		type: DetailsTableFormValueTypes;
		onClick?: () => void;
		types?: graphql.GroupType[];
		single?: boolean;
		required?: boolean;
		disabled?: boolean;
		placeholder?: string;
		loading?: boolean;
		description?: string;
		control?: ReactNode;
		// Select props
		search?: boolean;
		// ImageUpload props
		accept?: string[];
		onUpload?: (file: File) => Promise<{ id: string; url: string }>;
		uploading?: boolean;
		// Quill props
		hasMediaUpload?: boolean;
	}[];
	onEditingForm?: (isEditingForm: boolean) => void;
}

export default function DetailsTableForm({
	formValues,
	onEditingForm = () => {},
}: IProps): ReactElement {
	const { t } = useTranslation();

	return (
		<Box>
			{formValues.map((item) => {
				const { description, control, ...valueProps } = item;

				return (
					<Fragment key={item.name}>
						<Flex
							alignItems={description ? 'flex-start' : 'center'}
							flexWrap="wrap"
							justifyContent="space-between"
							minHeight={64}
						>
							<Box width={[12 / 12, 12 / 12, 3 / 12]} mb={[1, 1, 0]}>
								<Label>{item.label}</Label>
							</Box>

							<Box width={[12 / 12, 12 / 12, 9 / 12]}>
								{description && <Paragraph mb={`${tokens.gap.list}px`}>{description}</Paragraph>}
								{control ?? (
									<DetailsTableFormValue
										{...valueProps}
										onEditingForm={(isEditingForm) => onEditingForm(isEditingForm)}
									/>
								)}
							</Box>
						</Flex>
						<FieldErrorMessage
							name={item.name}
							validationMessage={
								item.type === DetailsTableFormValueTypes.Multilingual
									? t('errors.validation.emptyMultilingualError')
									: undefined
							}
						/>
					</Fragment>
				);
			})}
		</Box>
	);
}
